module.exports = __webpack_public_path__ + "img/Analysis.31709fc3.svg";